import { render, staticRenderFns } from "./sbsp-form-list.vue?vue&type=template&id=3dfd6d54&scoped=true&"
import script from "./sbsp-form-list.vue?vue&type=script&lang=js&"
export * from "./sbsp-form-list.vue?vue&type=script&lang=js&"
import style0 from "./sbsp-form-list.vue?vue&type=style&index=0&id=3dfd6d54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfd6d54",
  null
  
)

export default component.exports